module.exports = __webpack_public_path__ + "img/電気回路_2_5_3.d4ff38ed.png";